import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";
class ChatStore extends EventEmitter {
    constructor() {
        super();
        this.userId='';
        this.userName='';
    }

    getChatObject(){
        return {
            userId: this.userId,
            userName: this.userName
        };
    }

    handleActions(action) {
        switch (action.type) {
            case "SELECT_CHAT_USER":
            {
                this.userId=action.payload.userId
                this.userName=action.payload.userName
                this.emit("change");
                break
            }
            default:
                break
        }
    }

}

const chatStore = new ChatStore();
dispatcher.register(chatStore.handleActions.bind(chatStore));

export default chatStore;



// WEBPACK FOOTER //
// ./src/stores/ChatStore.js